import React from 'react';
import * as Ons from 'react-onsenui';
import Toolbar from '../Toolbar';
import RosterPlayers from '../../containers/Pages/RosterPlayers';
import Eligibles from '../../containers/Pages/Eligibles';
import { translate as _ } from '../../util/i18n';
import { expired, getActionButtonPosition, getRosterPublicStatusClass, hasLocalChanges, shorten } from '../../util';
import { supports, wording } from '../../util/context';
import { showAlert } from '../../util/ui';
import { parseKey } from '../../util/reducer-helpers';
import { FACECHECK_ALLOWED, READY_TO_PLAY, ROSTERS_LOCKED, ROSTERS_UNLOCKED } from '../../store/constants/statusCodes';
import { POSITION_GOALKEEPER } from '../../store/constants/misc';
import LineupEditor from './LineupEditor';

class Rosters extends React.Component {

    #actionButtonClass;
    #pullHookCallback;
    #pullHookTimeout;
    #team;
    #teamId;

    constructor( props ) {

        // console.log( 'components.Pages.Rosters.constructor()', props );

        super( props );

        this.state = {
            eligiblesOpen:    false,
            lineupEditorOpen: false,
            pullHook:         'initial',
            speedDialOpen:    true,
            tabIndex:         this.props.activeGame.permission === 'away' ? 1 : 0
        };

        this.handleBackClick            = this.handleBackClick.bind( this );
        this.handleCancelEligibles      = this.handleCancelEligibles.bind( this );
        this.handleCancelLineupEditor   = this.handleCancelLineupEditor.bind( this );
        this.handleConfirmRosterPlayers = this.handleConfirmRosterPlayers.bind( this );
        this.handleLoadRosters          = this.handleLoadRosters.bind( this );
        this.handleLockRosters          = this.handleLockRosters.bind( this );
        this.handleOpenEligibles        = this.handleOpenEligibles.bind( this );
        this.handleOpenLineupEditor     = this.handleOpenLineupEditor.bind( this );
        this.handleOpenRosters          = this.handleOpenRosters.bind( this );
        this.handlePublishRoster        = this.handlePublishRoster.bind( this );
        this.handlePullHookChange       = this.handlePullHookChange.bind( this );
        this.handlePullHookLoad         = this.handlePullHookLoad.bind( this );
        this.handleReadyToPlay          = this.handleReadyToPlay.bind( this );
        this.handleSubmitEligibles      = this.handleSubmitEligibles.bind( this );
        this.handleSubmitLineup         = this.handleSubmitLineup.bind( this );
        this.handleTabChange            = this.handleTabChange.bind( this );
        this.handleUnlockRosters        = this.handleUnlockRosters.bind( this );
        this.handleUnreadyToPlay        = this.handleUnreadyToPlay.bind( this );

        if ( this.props.activeGame.permission === 'home' ) {

            this.#team   = 'home';
            this.#teamId = this.props.activeGame.homeTeam.id;

        } else if ( this.props.activeGame.permission === 'away' ) {

            this.#team   = 'away';
            this.#teamId = this.props.activeGame.awayTeam.id;

        }

        this.#actionButtonClass = 'bottom ' + [ 'left', 'center', 'right' ][ getActionButtonPosition( this.props.userSettings ) ];

    }

    componentDidMount() {

        expired( this.props.rosters && this.props.rosters.lastUpdate ) && this.handleLoadRosters();

    }

    componentDidUpdate() {

        if ( this.#pullHookCallback ) {

            clearTimeout( this.#pullHookTimeout );

            const pullHookCallback = this.#pullHookCallback;
            this.#pullHookTimeout  = setTimeout( () => pullHookCallback(), 1000 );
            this.#pullHookCallback = null;

        }

    }

    fixSpeedDial() {

        setTimeout( () => this.setState( { speedDialOpen: true } ), 1 );

    }

    handleBackClick() {

        this.props.onChangePage( { page: 'game' } );

    }

    handleCancelEligibles() {

        this.props.error && this.props.onDismissError();

        this.setState( { eligiblesOpen: false } );

    }

    handleCancelLineupEditor() {

        this.setState( { lineupEditorOpen: false } );

    }

    handleConfirmRosterPlayers() {

        this.setState( { speedDialOpen: false }, () => {

            const confirmedRosterPlayers = [];

            this.props.mergedAwayRoster && this.props.mergedAwayRoster.forEach( player => player.isConfirmed && confirmedRosterPlayers.push( player.id )  );
            this.props.mergedHomeRoster && this.props.mergedHomeRoster.forEach( player => player.isConfirmed && confirmedRosterPlayers.push( player.id )  );

            this.props.onConfirmRosterPlayers( this.props.context, this.props.token, this.props.activeGame.id, confirmedRosterPlayers );

            this.fixSpeedDial();

        } );

    }

    handleLoadRosters() {

        this.props.error && this.props.onDismissError();

        this.props.onLoadRosters( this.props.context, this.props.token, this.props.activeGame.id );

    }

    handleLockRosters() {

        this.setState( { speedDialOpen: false }, () => {

            this.setRosterStatus( 'lockRosters' );

            this.fixSpeedDial();

        } );

    }

    handleOpenEligibles() {

        this.setState( { eligiblesOpen: true } );

    }

    handleOpenLineupEditor() {

        this.setState( { lineupEditorOpen: true } );

    }

    handleOpenRosters() {

        this.setState( { speedDialOpen: false }, () => {

            this.setRosterStatus( 'unlockRosters' );

            this.fixSpeedDial();

        } );

    }

    handlePublishRoster() {

        this.setState( { speedDialOpen: false }, () =>  {

            this.props.onPublishRoster( this.props.context, this.props.token, this.props.activeGame.id, this.#team, this.#teamId, ! this.rosterIsPublic() );

            this.fixSpeedDial();

        } );

    }

    handlePullHookChange( e ) {

        this.setState( { pullHook: e.state } );

    }

    handlePullHookLoad( e ) {

        this.#pullHookCallback = e;

        this.handleLoadRosters();

    }

    handleReadyToPlay() {

        this.setState( { speedDialOpen: false }, () => {

            if ( hasLocalChanges( [ this.props.mergedAwayRoster || [], this.props.mergedHomeRoster || [] ] ) ) {

                showAlert( {

                    buttonLabels: [ _( 'Abbrechen' ), _( 'OK' ) ],
                    callback:     e => e === 1 && this.setRosterStatus( 'readyToPlay' ),
                    cancelable:   true,
                    message:      _( wording( this.props.context, 'lineup' ) ? 'Es wurden Spieler confirmed, die Aufstellung aber noch nicht bestätigt. Fortfahren?' : 'Es wurden Spieler confirmed, der Roster aber noch nicht bestätigt. Fortfahren?' ),
                    title:        _( 'Achtung' )

                } );

            } else if ( ! this.hasConfirmedPlayers( [ this.props.mergedAwayRoster || [], this.props.mergedHomeRoster || [] ] ) ) {

                showAlert( {

                    buttonLabels: [ _( 'Abbrechen' ), _( 'OK' ) ],
                    callback:     e => e === 1 && this.setRosterStatus( 'readyToPlay' ),
                    cancelable:   true,
                    message:      _( 'Es wurden keine Spieler confirmed. Fortfahren?' ),
                    title:        _( 'Achtung' )

                } );

            } else {

                this.setRosterStatus( 'readyToPlay' );

            }

            this.fixSpeedDial();

        } );

    }

    handleSubmitEligibles( selectedPlayers, selectedTeamOfficials ) {

        const state = { eligiblesOpen: false }

        selectedPlayers.map( selectedPlayer => {

            selectedPlayer.lineupData = {

                jerseyNr: selectedPlayer.jerseyNr || null,
                position: selectedPlayer.position || null

            };

            if ( supports( this.props.context, 'captain'        ) ) { selectedPlayer.lineupData.captain  = selectedPlayer.captain  || null; }
            if ( supports( this.props.context, 'startingPlayer' ) ) { selectedPlayer.lineupData.starting = selectedPlayer.starting || null; }
            if ( supports( this.props.context, 'lineup'         ) ) { selectedPlayer.lineupData.line     = this.props.simpleLineup && selectedPlayer.lineupData.position !== POSITION_GOALKEEPER ? 1 : selectedPlayer.selectedLine || selectedPlayer.line || null; }

            return selectedPlayer;

        } );

        if ( supports( this.props.context, 'teamOfficials' ) ) {

            selectedTeamOfficials.map( selectedTeamOfficial => {

                parseKey( selectedTeamOfficial, 'additionalData' );

                selectedTeamOfficial.lineupData = { job: selectedTeamOfficial.additionalData.job || null };

                return selectedTeamOfficial;

            } );

        }

        if ( supports( this.props.context, 'lineup' ) && ! this.props.simpleLineup ) {

            state.lineupEditorOpen = true;

        }

        this.props.error && this.props.onDismissError();

        this.setState( state );

        this.props.onAddPlayersToRoster( this.props.context, this.props.token, this.props.activeGame.id, this.#team, this.#teamId, selectedPlayers, supports( this.props.context, 'teamOfficials' ) ? selectedTeamOfficials : null );

    }

    handleSubmitLineup( roster ) {

        const players = []

        roster.forEach( player => players.push( { playerId: player.id, lineupData: player.lineupData } ) );

        this.props.error && this.props.onDismissError();

        this.props.onEditRosterPlayers( this.props.context, this.props.token, this.props.activeGame.id, this.#team, this.#teamId, players );

    }

    handleTabChange( e ) {

        this.setState( { tabIndex: e.index } );

    }

    handleUnlockRosters() {

        this.setState( { speedDialOpen: false }, () => {

            this.setRosterStatus( 'unlockRosters' );

            this.fixSpeedDial();

        } );

    }

    handleUnreadyToPlay() {

        this.setState( { speedDialOpen: false }, () => {

            this.setRosterStatus( 'unreadyToPlay' );

            this.fixSpeedDial();

        } );

    }

    hasConfirmedPlayers( e ) {

        for ( let i = 0; i < e.length; i++ ) {

            for ( let j = 0; j < e[ i ].length; j++ ) {

                if ( e[ i ][ j ].isConfirmed ) {

                    return true;

                }

            }

        }

        return false;

    }

    rosterIsPublic() {

        return ( this.#team === 'home' ? this.props.rosters.items.homeRosterIsPublic : this.props.rosters.items.awayRosterIsPublic );

    }

    setRosterStatus( command ) {

        this.props.onSetRosterStatus( this.props.context, this.props.token, this.props.activeGame.id, command );

    }

    render() {

        // console.log( 'components.Pages.Rosters.render()', this.props, this.state );

        let awayPlayersConfirmed = 0;
        let homePlayersConfirmed = 0;

        this.props.mergedAwayRoster && this.props.mergedAwayRoster.forEach( e => { e.isConfirmed && awayPlayersConfirmed++; } );
        this.props.mergedHomeRoster && this.props.mergedHomeRoster.forEach( e => { e.isConfirmed && homePlayersConfirmed++; } );

        const awayTeamTabLabel = this.props.activeGame.awayTeam.shortName + ( this.props.activeGame.permission === 'referee' ? ' (' + awayPlayersConfirmed + '/' + ( this.props.mergedAwayRoster ? this.props.mergedAwayRoster.length: 0 ) + ')' : '' );
        const homeTeamTabLabel = this.props.activeGame.homeTeam.shortName + ( this.props.activeGame.permission === 'referee' ? ' (' + homePlayersConfirmed + '/' + ( this.props.mergedHomeRoster ? this.props.mergedHomeRoster.length: 0 ) + ')' : '' );
        const loading          = this.props.loading && this.state.pullHook !== 'action';
        const title            = [];
        const rosterStatus     = this.props.rosters && this.props.rosters.items && this.props.rosters.items.rosterStatus;

        title.push( <span key="date">{this.props.activeGame.dateIsToBeDetermined ? _( 'TBD' ) : this.props.activeGame.scheduledDate.shortValue}</span> );
        title.push( <span key="teams"> {shorten( this.props.activeGame.homeTeam.shortName ) + '-' + shorten( this.props.activeGame.awayTeam.shortName )} </span> );

        ! rosterStatus                    && title.push( <Ons.Icon icon='fa-ban'  key="roster-status" /> );
          rosterStatus === ROSTERS_LOCKED && title.push( <Ons.Icon icon='fa-lock' key="roster-status" /> );
          rosterStatus === READY_TO_PLAY  && title.push( <Ons.Icon icon='fa-play' key="roster-status" /> );

        return (

            this.state.lineupEditorOpen ?

                <LineupEditor onSubmit={this.handleSubmitLineup} onCancel={this.handleCancelLineupEditor} roster={this.props.activeGame.permission === 'home' ? this.props.mergedHomeRoster : this.props.mergedAwayRoster} loading={loading} />

            : this.state.eligiblesOpen ?

                <Eligibles onSubmit={this.handleSubmitEligibles} onCancel={this.handleCancelEligibles} teamId={this.#teamId} roster={this.props.activeGame.permission === 'home' ? this.props.mergedHomeRoster : this.props.mergedAwayRoster} simpleLineup={this.props.simpleLineup} />

            :

                <Ons.Page renderToolbar={() => <Toolbar title={title} onBackClick={this.handleBackClick} onMenuClick={this.props.onMenuClick} onReloadClick={this.handleLoadRosters} />}>

                    {

                            <>

                                {loading && <Ons.ProgressBar indeterminate className="fixed-progress-bar" />}

                                <Ons.Tabbar
                                    index={this.state.tabIndex}
                                    className="tabbar-fix"
                                    position="bottom"
                                    renderTabs={ () => [
                                        {
                                            content: <RosterPlayers
                                                key="tab-content-home"
                                                onLoadPlayers={this.handleLoadRosters}
                                                onPullHookChange={this.handlePullHookChange}
                                                onPullHookLoad={this.handlePullHookLoad}
                                                playersActivatable={this.props.activeGame.permission === 'referee' && rosterStatus === ROSTERS_LOCKED}
                                                team="home"
                                            />,
                                            tab: <Ons.Tab label={homeTeamTabLabel} key="tab-button-home" className={getRosterPublicStatusClass( this.props.context, this.props.rosters && this.props.rosters.items, 'home' ) || ''} />
                                        }, {
                                            content: <RosterPlayers
                                                key="tab-content-away"
                                                onLoadPlayers={this.handleLoadRosters}
                                                onPullHookChange={this.handlePullHookChange}
                                                onPullHookLoad={this.handlePullHookLoad}
                                                playersActivatable={this.props.activeGame.permission === 'referee' && rosterStatus === ROSTERS_LOCKED}
                                                team="away"
                                            />,
                                            tab: <Ons.Tab label={awayTeamTabLabel} key="tab-button-away" className={getRosterPublicStatusClass( this.props.context, this.props.rosters && this.props.rosters.items, 'away' ) || ''} />
                                        }
                                    ] }
                                    swipeable
                                    onPostChange={this.handleTabChange}
                                />

                                {

                                    this.props.activeGame.permission === 'referee' ?

                                        this.state.speedDialOpen &&
                                            <Ons.SpeedDial position={this.#actionButtonClass} style={{ bottom: '70px' }}>

                                                {! rosterStatus                    && <Ons.SpeedDialItem modifier="large" onClick={this.handleOpenRosters}  ><Ons.Icon icon='fa-unlock' /> {_( wording( this.props.context, 'lineup' ) ? 'Aufstellungen öffnen'     : 'Roster öffnen'     )}</Ons.SpeedDialItem>}
                                                {rosterStatus === ROSTERS_UNLOCKED && <Ons.SpeedDialItem modifier="large" onClick={this.handleLockRosters}  ><Ons.Icon icon='fa-lock'   /> {_( wording( this.props.context, 'lineup' ) ? 'Aufstellungen sperren'    : 'Roster sperren'    )}</Ons.SpeedDialItem>}
                                                {rosterStatus === ROSTERS_LOCKED   && <Ons.SpeedDialItem modifier="large" onClick={this.handleUnlockRosters}><Ons.Icon icon='fa-unlock' /> {_( wording( this.props.context, 'lineup' ) ? 'Aufstellungen entsperren' : 'Roster entsperren' )}</Ons.SpeedDialItem>}
                                                {rosterStatus === ROSTERS_LOCKED   && <Ons.SpeedDialItem modifier="large" onClick={this.handleReadyToPlay}  ><Ons.Icon icon='fa-play'   /> {_( 'Ready to Play' )}</Ons.SpeedDialItem>}
                                                {rosterStatus === READY_TO_PLAY    && <Ons.SpeedDialItem modifier="large" onClick={this.handleUnreadyToPlay}><Ons.Icon icon='fa-stop'   /> {_( 'Unready to Play' )}</Ons.SpeedDialItem>}
                                                {rosterStatus === ROSTERS_LOCKED   && ( this.props.facecheckAway === FACECHECK_ALLOWED || this.props.facecheckHome === FACECHECK_ALLOWED ) && <Ons.SpeedDialItem modifier="large" onClick={this.handleConfirmRosterPlayers}><Ons.Icon icon='fa-check' /> {_( wording( this.props.context, 'lineup' ) ? 'Aufstellung bestätigen' : 'Roster bestätigen' )}</Ons.SpeedDialItem>}

                                                <Ons.Fab><Ons.Icon icon='fa-bars' /></Ons.Fab>

                                            </Ons.SpeedDial>

                                    :

                                        rosterStatus === ROSTERS_UNLOCKED

                                        && ( ( this.state.tabIndex === 0 && this.props.activeGame.permission === 'home' ) || ( this.state.tabIndex === 1 && this.props.activeGame.permission === 'away' ) )

                                        && (

                                            supports( this.props.context, 'rosterPublishing' ) ?

                                                (

                                                    this.state.speedDialOpen &&
                                                        <Ons.SpeedDial position={this.#actionButtonClass} style={{ bottom: '70px' }}>
                                                            <Ons.SpeedDialItem modifier="large" onClick={this.handleOpenEligibles}><Ons.Icon icon='fa-plus' /> {supports( this.props.context, 'teamOfficials' ) ? _( 'Spieler/Team-Offizielle hinzufügen' ) : _( 'Spieler hinzufügen' )}</Ons.SpeedDialItem>
                                                            {supports( this.props.context, 'lineup' ) && ! this.props.simpleLineup && <Ons.SpeedDialItem modifier="large" onClick={this.handleOpenLineupEditor}><Ons.Icon icon='fa-stream' /> {_( 'Linien bearbeiten' )}</Ons.SpeedDialItem>}
                                                            <Ons.SpeedDialItem modifier="large" onClick={this.handlePublishRoster}>{this.rosterIsPublic() ? <><Ons.Icon icon='fa-eye-slash' /> {_( wording( this.props.context, 'lineup' ) ? 'Aufstellung nicht veröffentlichen' : 'Roster nicht veröffentlichen' )}</> : <><Ons.Icon icon='fa-eye' /> {_( wording( this.props.context, 'lineup' ) ? 'Aufstellung veröffentlichen' : 'Roster veröffentlichen' )}</>}</Ons.SpeedDialItem>
                                                            <Ons.Fab><Ons.Icon icon='fa-bars' /></Ons.Fab>
                                                        </Ons.SpeedDial>

                                                )

                                            :

                                                <Ons.Fab position={this.#actionButtonClass} style={{ bottom: '70px' }} ripple={true} onClick={this.handleOpenEligibles}><Ons.Icon icon='fa-plus' /></Ons.Fab>

                                        )

                                }

                            </>

                    }


                </Ons.Page>

        );

    }

}

export default Rosters;